import { render } from "./Formulario.vue?vue&type=template&id=7f015a20&scoped=true"
import script from "./Formulario.vue?vue&type=script&lang=js"
export * from "./Formulario.vue?vue&type=script&lang=js"

import "./Formulario.vue?vue&type=style&index=0&id=7f015a20&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f015a20"]])

export default __exports__